<template>
    <main-layout class="bg-gray-100 min-h-screen flex flex-col">

        <!-- En-tête + CTA sur fond dégradé -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <div class="px-2 py-3">
                <app-header icon="tools" class="text-white">
                    <div class="flex items-center justify-between">
                        <h1 class="text-2xl font-semibold tracking-wide">Interventions</h1>
                    </div>
                </app-header>
                <!-- Action principale (garde id=main-action pour le JS) -->
                <action-bar :back="{ name: 'home' }" class="!p-0  mb-2">
                    <router-link
                        class="inline-flex items-center gap-2 bg-white text-primary text-sm font-medium px-4 py-2 rounded-lg shadow-sm hover:shadow transition"
                        id="main-action" to="new-fibsdd">
                        <i class="inline-block h-6 w-6 mask mask-more bg-primary"></i>
                        <span><strong>Nouvelle</strong> intervention</span>
                    </router-link>
                </action-bar>

                <!-- Section recherche -->
                <div>
                    <filter-bar @searchBarChanged="updateSearch"
                        placeholderFilter="Rechercher par numéro, raison sociale…" class="block pb-5" />
                </div>
            </div>
        </div>

        <!-- Contenu principal : liste -->
        <div
            class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28">
            <div class="mx-1 my-2 mb-40 shadow-2xl rounded-2xl overflow-hidden">

                <!-- Carte/liste -->
                <div id="list-interventions" class="list rounded-2xl overflow-hidden shadow-2xl">
                    <fibsdd-item v-for="fi in filterList" :key="fi.id" :fibsdd="fi"
                        :detenteur="detenteurs[fi.detenteur]" :installation="installations[fi.installation]"
                        :idUser="idUser" class="block w-full" />
                </div>
            </div>
        </div>

    </main-layout>
</template>


<script>
import FibsddItem from './FibsddItem.vue'
import Fibsdd from '../../../js/models/Fibsdd'
import Detenteur from '../../../js/models/Detenteur'
import Installation from '../../../js/models/Installation'
import User from "../../../js/models/User";

export default {
    data() {
        return {
            filterList: [],
            detenteurs: {},
            installations: {},
            interventions: [],
            strSearch: '',
            idUser: null
        }
    },
    computed: {

    },
    methods: {
        updateSearch(str) {
            this.filterList = this.interventions;
            this.strSearch = String(str[0]).toLowerCase()
            this.filterList = this.filterList.filter(fi => {

                let check = false;
                let search = this.strSearch;


                if (_.has(fi, 'detenteurString') && fi.detenteurString !== "") {
                    if (fi.detenteurString.toLowerCase().includes(search)) { check = true }
                }

                if (_.has(fi, 'numero') && null !== fi.numero) {
                    if (fi.numero.toLowerCase().includes(search)) { check = true }
                }

                if (_.has(fi, 'ordre_travail') && fi.ordre_travail != null && fi.ordre_travail.toLowerCase().includes(search)) {
                    check = true
                }

                if (!_.has(fi, 'ordre_travail') && !_.has(fi, 'numero')) {
                    check = true
                }

                if (check === true) {
                    return fi;
                }


            }).reverse();


        }
    },
    async mounted() {

        this.idUser = (await User.getUserInfo()).id;

        let fi = new Fibsdd;
        let tempList = [];

        tempList = await fi.getList();
        tempList = tempList.filter(fi => {
            return fi.cloture !== true;
        })

        tempList.sort((a, b) => {
            if (a.affectation_user === this.idUser && b.affectation_user !== this.idUser) {
                return -1;
            }
            if (b.affectation_user === this.idUser && a.affectation_user !== this.idUser) {
                return 1;
            }

            // Sinon, tri par id DESC
            return b.id - a.id;
        });


        this.interventions = tempList;

        // Extraire les IDs uniques pour detenteur et installation
        const detenteurIds = [...new Set(tempList.map(fi => fi.detenteur))];
        const installationIds = [...new Set(tempList.map(fi => fi.installation))];

        // Charger toutes les detenteurs
        const detenteurPromises = detenteurIds.map(id => Detenteur.getDetenteur(id));
        const detenteursData = await Promise.all(detenteurPromises);
        detenteursData.forEach(det => {
            this.$set(this.detenteurs, det.id, det);
        });

        // Charger toutes les installations
        const installationPromises = installationIds.map(id => Installation.getInstallation(id));
        const installationsData = await Promise.all(installationPromises);
        installationsData.forEach(install => {
            this.$set(this.installations, install.id, install);
        });

        // Déterminer la supprimabilité
        const supprimablePromises = tempList.map(fi => Fibsdd.isInitied(fi.id));
        const supprimableResults = await Promise.all(supprimablePromises);
        tempList.forEach((fi, index) => {
            fi.supprimable = supprimableResults[index];
        });

        this.filterList = tempList;
    },
    components: {
        FibsddItem
    }
}

</script>



// WEBPACK FOOTER //
// ListeFibsdd.vue?0ff77948